// extracted by mini-css-extract-plugin
export default {"table":"table_table","table_hasFixedLayout":"table_table_hasFixedLayout"};